import { StatusBadge } from './Components/StatusBadge';

export default StatusBadge;
